import * as React from "react";

function SvgImager(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" {...props}>
      <path
        d="M31.125 25.5a.625.625 0 100-1.25.625.625 0 000 1.25zM26.958 21.75a.52.52 0 11-1.042 0 .52.52 0 011.042 0zM23.625 28a.625.625 0 100-1.25.625.625 0 000 1.25zM30.604 32.688a1.042 1.042 0 11-2.083 0 1.042 1.042 0 012.083 0zM23.312 33.209a.52.52 0 100-1.042.52.52 0 000 1.042z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.938 28c0 6.04-4.897 10.938-10.938 10.938-6.04 0-10.938-4.897-10.938-10.938 0-6.04 4.897-10.938 10.938-10.938 6.04 0 10.938 4.897 10.938 10.938zm-4.688-3.125a3.125 3.125 0 11-6.25 0 3.125 3.125 0 016.25 0zM28 21.75a1.562 1.562 0 11-3.125 0 1.562 1.562 0 013.125 0zm-2.5 5.625a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm7.188 5.313a3.125 3.125 0 11-6.25 0 3.125 3.125 0 016.25 0zm-9.376 1.562a1.562 1.562 0 100-3.125 1.562 1.562 0 000 3.125z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 15.727C13 14.347 14.347 13 15.727 13h24.546C41.653 13 43 14.347 43 15.727v24.546C43 41.653 41.653 43 40.273 43H15.727C14.347 43 13 41.654 13 40.273V15.727zM40.5 28c0 6.904-5.596 12.5-12.5 12.5S15.5 34.904 15.5 28 21.096 15.5 28 15.5 40.5 21.096 40.5 28z"
        fill="#fff"
      />
      <circle cx={28} cy={28} r={27} stroke="#fff" />
    </svg>
  );
}

export default SvgImager;
